/**
 * Lightweight Sentry hook — no-ops unless REACT_APP_SENTRY_DSN is set
 * and @sentry/react is installed. Avoids hard dependency for local/dev.
 */

let sentry = null;
let initPromise = null;

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn || initPromise) return initPromise;

  initPromise = import('@sentry/react')
    .then((Sentry) => {
      Sentry.init({
        dsn,
        environment: process.env.NODE_ENV || 'development',
        tracesSampleRate: 0.1,
        ignoreErrors: [
          'ResizeObserver loop',
          'Non-Error promise rejection',
        ],
      });
      sentry = Sentry;
      return Sentry;
    })
    .catch(() => {
      // Package not installed — stay silent; ErrorBoundary still works.
      if (process.env.NODE_ENV === 'development') {
        console.info('[sentry] @sentry/react not available; error boundary will log locally only.');
      }
      return null;
    });

  return initPromise;
}

export function captureException(error, context = {}) {
  if (sentry?.captureException) {
    sentry.captureException(error, { extra: context });
    return;
  }
  if (process.env.NODE_ENV !== 'production') {
    console.error('[ErrorBoundary]', error, context);
  }
}

export function captureMessage(message, level = 'info') {
  if (sentry?.captureMessage) {
    sentry.captureMessage(message, level);
  }
}
